<template>
  <oie-my-pages-template
    :title="currentInvoice.documentType + ' ' + currentInvoice.ocr"
    class="invoice-history-details"
    :with-go-back="true">
    <div
      v-element-loader="{ endpoint: 'invoice' }"
      class="main main--invoice-history-details">
      <!--
    <div class="history-details__top">

  <div class="history-details__header-wrapper">
    <h2 v-epi-edit="'invoiceDetailsHeader'" class="history-details__header">
      {{ t("invoiceDetailsHeader") }}
    </h2>
    <a
      v-if="invoice.invoiceHead.goodsInformationNo"
      target="_blank"
      rel="noopener noreferrer"
      :href="invoice.invoiceHead.goodsInformationUrl"
      class="button button-link button-link--narrow button--icon-right history-details__button-track-invoice">
      {{ t("trackinvoice") }}
      <oie-use-svg
        svg="new-tab"
        css-classes="navigation-item__icon"></oie-use-svg>
    </a>
    <a
      :href="`${clientModel.invoiceReturnUrl}?invoiceNumber=${invoice.invoiceHead.invoiceNr}`"
      class="button button-link button-link--narrow button--icon-right">
      {{ t("invoiceReturn") }}
      <oie-use-svg
        svg="new-tab"
        css-classes="navigation-item__icon"></oie-use-svg>
    </a>
  </div>

      <p v-epi-edit="'invoiceDetailsDescription'" class="history-details__text">
        {{ t("invoiceDetailsDescription") }}
      </p>
    </div>
        -->

      <div v-if="invoice" class="grid grid--three history-details__information">
        <div class="history-details__information-box">
          <h3
            v-epi-edit="'detailsInvoiceInformationHeader'"
            class="history-details__information-header">
            {{ t("detailsInvoiceInformationHeader") }}
            <!-- invoicenummer information -->
          </h3>

          <div class="history-details__information-details">
            <div class="history-details__information-details-row">
              <div
                v-epi-edit="'detailsInvoiceNumberLabel'"
                class="history-details__information-details-key">
                {{ t("detailsInvoiceNumberLabel") }}
                <!-- invoicenummer: -->
              </div>
              <div class="history-details__information-details-value">
                {{ currentInvoice.ocr }}
                <!-- {{ $route.params.invoice_id }} -->
              </div>
            </div>

            <div class="history-details__information-details-row">
              <div
                v-epi-edit="'detailsDocumentTypeLabel'"
                class="history-details__information-details-key">
                {{ t("detailsDocumentTypeLabel") }}
                <!-- Best�llningssatum: -->
              </div>
              <div class="history-details__information-details-value">
                {{ currentInvoice.documentType }}
              </div>
            </div>

            <div class="history-details__information-details-row">
              <div
                v-epi-edit="'detailsInvoiceDateLabel'"
                class="history-details__information-details-key">
                {{ t("detailsInvoiceDateLabel") }}
                <!-- Best�llningssatum: -->
              </div>
              <div class="history-details__information-details-value">
                {{ currentInvoice.displayInvoiceDate }}
              </div>
            </div>

            <div class="history-details__information-details-row">
              <div
                v-epi-edit="'detailsInvoiceDueDateLabel'"
                class="history-details__information-details-key">
                {{ t("detailsInvoiceDueDateLabel") }}
                <!-- Best�llningssatum: -->
              </div>
              <div class="history-details__information-details-value">
                {{ currentInvoice.displayDueDate }}
              </div>
            </div>

            <div class="history-details__information-details-row">
              <div
                v-epi-edit="'invoicePaymentMethodLabel'"
                class="history-details__information-details-key">
                {{ t("detailsDownloadInvoiceLabel") }}
                <!-- H�mta faktura: -->
              </div>
              <div class="history-details__information-details-value">
                <div class="history-details-invoice__container">
                  <!--
            <a v-for="invoice in invoice.invoiceHead.invoices"
               :key="invoice.invoiceNumber"
               :href="invoice.invoicePdfUrl"
               download
               class="history-details-invoice__number">
              {{ invoice.invoiceNumber }}

              <oie-use-svg svg="download-invoice"></oie-use-svg>
            </a>
              -->
                  <a :href="`/mvcapi/se/sv/invoice/invoice-document/${currentInvoice.invoiceNumber}`" class="history-details-invoice__number" @click="downloadFile(invoice, $event.target)">
                    {{ currentInvoice.invoiceNumber }}
                    <oie-use-svg svg="download-invoice"></oie-use-svg><span v-if="mq('small')"></span>
                  </a>
                </div>
              </div>
            </div>

            <!--
      <div class="history-details__information-details-row">
        <div v-epi-edit="'invoiceCommentLabel'"
             class="history-details__information-details-key">
          {{ t("detailsInvoiceCommentLabel") }}

          </div>
          <div class="history-details__information-details-value">
            {{ currentInvoice.comment }}
          </div>
        </div>
        -->
          </div>
        </div>

        <div class="history-details__information-box">
          <h3
            v-epi-edit="'invoiceDeliveryAddressHeader'"
            class="history-details__information-header">
            {{ t("detailsInvoiceDeliveryAddressHeader") }}
            <!-- Leveransadress -->
          </h3>

          <div class="history-details__information-details-row">
            <div
              v-if="clientModel.impersonating !== null"
              v-epi-edit="'detailsCustomerNumberLabel'"
              class="history-details__information-details-key">
              {{ t("detailsCustomerNumberLabel") }}
              <!-- Best�llningssatum: -->
            </div>
            <div class="history-details__information-details-value">
              {{ currentInvoice.sellToCustomerNumber }}
            </div>
          </div>

          <div class="history-details__information-details-row">
            <div
              v-epi-edit="'detailsOrderNumberLabel'"
              class="history-details__information-details-key">
              {{ t("detailsOrderNumberLabel") }}
              <!-- Best�llningssatum: -->
            </div>
            <div class="history-details__information-details-value">
              {{ currentInvoice.orderNumber }}
            </div>
          </div>

          <div class="history-details__information-details-row">
            <div
              v-epi-edit="'detailsInvoiceStatusLabel'"
              class="history-details__information-details-key">
              {{ t("detailsInvoiceStatusLabel") }}
              <!-- Best�llningssatum: -->
            </div>
            <div class="history-details__information-details-value">
              {{ currentInvoice.displayStatus }}
            </div>
          </div>

          <div class="history-details__information-details-row">
            <div
              v-epi-edit="'detailsInvoiceReferenceLabel'"
              class="history-details__information-details-key">
              {{ t("detailsInvoiceReferenceLabel") }}
              <!-- Best�llningssatum: -->
            </div>
            <div class="history-details__information-details-value">
              {{ currentInvoice.invoiceReference }}
            </div>
          </div>

          <div class="history-details__information-details-row">
            <div
              v-epi-edit="'detailsInvoiceReferenceLabel'"
              class="history-details__information-details-key">
              {{ t("detailsInvoiceExternalDocumentNumber") }}
              <!-- Best�llningssatum: -->
            </div>
            <div class="history-details__information-details-value">
              {{ currentInvoice.externalDocumentNumber }}
            </div>
          </div>
        </div>

        <div class="history-details__information-box">
          <h3
            v-epi-edit="'invoiceInvoiceAddressHeader'"
            class="history-details__information-header">
            {{ t("detailsInvoiceAddressHeader") }}
            <!-- Fakturaadress -->
          </h3>

          <div class="history-details__information-details-row">
            <!--
  <div v-epi-edit="'detailsInvoiceCommentLabel'"
       class="history-details__information-details-key">
    {{ t("detailsInvoiceCommentLabel") }}

  </div>
  -->
            <div class="history-details__information-details-value">
              {{ currentInvoice.comment }}
            </div>
          </div>

          <div class="history-details__information-address">
            <div class="history-details__information-address-row">
              {{ invoice.invoiceHead.invoiceAddress.name }}
            </div>
            <div class="history-details__information-address-row">
              {{ invoice.invoiceHead.invoiceAddress.address1 }}
              <template v-if="invoice.invoiceHead.invoiceAddress.address2">
                <br>
                {{ invoice.invoiceHead.invoiceAddress.address2 }}
              </template>
            </div>
            <div class="history-details__information-address-row">
              {{ invoice.invoiceHead.invoiceAddress.zipCode }}
              {{ invoice.invoiceHead.invoiceAddress.city }}
            </div>
            <div class="history-details__information-address-row">
              {{ invoice.invoiceHead.invoiceAddress.country }}
            </div>
          </div>
        </div>
      </div>

      <div class="history-details-products">
        <div v-epi-edit="'invoiceRowsHeader'" class="history-details-products__top">
          {{ t("detailsInvoiceRowsHeading") }}
        </div>

        <oie-invoice-history-details-product-table
          :rows="invoice.invoiceRows"
          class="history-details-products__table"></oie-invoice-history-details-product-table>

        <div class="history-details-products__summary">
          <div
            v-epi-edit="'detailsInvoiceAmountExcludingVatLabel'"
            class="history-details-products__summary-row">
            <!-- Betalningt exklusive moms -->
            {{ t("detailsInvoiceAmountExcludingVatLabel") }}
            <div class="history-details-products__summary-value">
              {{ formatPrice(currentInvoice.totalAmountExcludingTax) }}
            </div>
          </div>

          <div
            v-epi-edit="'detailsInvoiceVatLabel'"
            class="history-details-products__summary-row">
            {{ t("detailsInvoiceVatLabel") }}
            <!-- Moms -->
            <div class="history-details-products__summary-value">
              {{ formatPrice(currentInvoice.invoiceAmount - currentInvoice.totalAmountExcludingTax) }}
            </div>
          </div>

          <div
            v-epi-edit="'detailsInvoiceTotalAmountLabel'"
            class="history-details-products__summary-row">
            {{ t("detailsInvoiceTotalAmountLabel") }}
            <!-- Totalt (inklusive frakt och betalningsavgift) -->
            <div class="history-details-products__summary-value history-details-products__summary-value--larger">
              {{ formatPrice(currentInvoice.invoiceAmount) }}
            </div>
          </div>
        </div>

        <!--
  <oie-base-button
    v-epi-edit="'addToCartButtonLabel'"
    :text="t('addToCartButtonLabel')"
    :disabled="selectedHistoryRows.length === 0"
    css-classes="button--with-binvoice button--green"
    @click="addToCart"></oie-base-button>
    -->
      </div>
    </div>
  </oie-my-pages-template>
</template>

<script>
import { mapGetters } from 'vuex'
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  data: () => ({
    invoiceReturnSettings: {
      enabled: false
    },
    selectedHistoryRows: [],
    invoice: {
      invoiceNumber: 'lorem',
      invoiceHead: {
        invoiceNr: '',
        invoiceDate: '',
        displayinvoiceDate: '',
        customerNo: '',
        currency: '',
        paymentTerms: '',
        modeOfDelivery: '',
        shipmentId: '',
        ourRef: '',
        invoiceRefernce: '',
        shipmentCost: 0,
        packagingCost: 0,
        vatSum: 0,
        invoiceSum: 0,
        comment: '',
        goodsInformationNo: '',
        goodsInformationUrl: '',
        deliveryAddress: {
          name: '',
          address1: '',
          address2: '',
          zipCode: '',
          city: '',
          country: ''
        },
        invoiceAddress: {
          name: '',
          address1: '',
          address2: '',
          zipCode: '',
          city: '',
          country: ''
        }
      },
      invoiceRows: []
    }
  }),
  computed: {
    ...mapGetters('myInvoiceHistory', ['currentInvoice']),
    hasCustomFields() { return !_.isEmpty(this.currentInvoice.customFields) }
  },
  mounted() {
    if (this.currentInvoice.invoiceNumber !== '') {
      httpService
        .get(`invoice/${this.currentInvoice.invoiceNumber}/invoice-rows`, { invoiceNumber: this.currentInvoice.invoiceNumber })
        .then(response => {
          this.invoice.invoiceRows = response.data
        })
    }

    this.subscribe('invoice-history-rows-selection-updated', rows => {
      this.selectedHistoryRows = rows
    })
  },
  methods: {
    addToCart() {
      const payload = _.map(this.selectedHistoryRows, item => {
        return { itemId: item.artNr, quantity: item.quantity }
      })
      this.$store.dispatch('commerce/addListToCart', { rows: payload })
    },
    downloadFile(item, button) {
      button.classList.add('invoice-download-is-loading-small')

      setTimeout(() => {
        button.classList.remove('invoice-download-is-loading-small')
      }, 7000)
    }
  }
}
</script>

<style lang="scss">
  .main--invoice-history-details {
  }

  .history-details__top {
    margin-bottom: measure(double);
  }

  .history-details__header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .history-details__information {
    margin-bottom: measure(half);
  }

  .history-details__phone-link {
    margin-top: measure(quarter);
    color: color(text-blue);
  }

  .history-details__information-box {
    @include body-smaller;
    background-color: color(background-white);
    border: 1px solid color(border-gray);
    padding: measure(half);
  }

  .history-details__information-header {
    @include h3-semi-bold;
    margin-top: 0;
  }

  .history-details__information-details-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: measure(eighth);
  }

  .history-details__information-details-key,
  .history-details__information-details-value {
    flex-basis: 50%;
  }

  .history-details__information-address-row {
    margin-bottom: measure(eighth);
  }

  .history-details-products__top {
    @include body-semi-bold;
    display: flex;
    align-items: center;
    padding: measure(quarter) 0;
  }

  .history-details-products__table {
    margin-bottom: measure(half);
  }

  .history-details-products__summary {
    @include body-smaller;
    background-color: color(background-white);
    border: 1px solid color(border-gray);
    margin-bottom: measure(half);
    padding: measure(half);

    @include media(medium) {
      @include body;
    }
  }

  .history-details-products__summary-row {
    display: flex;
    flex-direction: column;
    margin-bottom: measure(half);

    &:last-child {
      margin-bottom: 0;
    }

    @include media(medium) {
      flex-direction: row;
      margin-bottom: measure(quarter);
    }
  }

  .history-details-products__summary-value {
    @include body-smaller-semi-bold;
    margin-left: 0;
    padding-top: measure(quarter);

    @include media(medium) {
      @include body-smaller-semi-bold;
      margin-left: auto;
      padding-top: 0;
    }
  }

  .history-details-products__summary-value--larger {
    @include body-semi-bold;

    @include media(medium) {
      @include h3-semi-bold;
    }
  }

  .history-details-invoice__container > * {
    vertical-align: middle;
    display: inline;
  }

  .history-details-invoice__number {
    @include reset-link;
    display: flex;
    align-items: center;
    margin-right: measure(quarter);

    & > svg {
      width: 1.4rem;
      height: 1.4rem;
      margin-left: measure(quarter);
    }
  }

  .history-details__button-track-invoice {
    margin-right: 1rem;
    margin-left: auto;
  }

  .invoice_ocr > :nth-child(2) {
    @include caption;
    color: color(gray-2);
  }

  .invoice-download-is-loading-small {
    position: relative;
    pointer-events: none;
    color: transparent !important;

    &:hover {
      cursor: default;
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: .825rem;
      transform: translate(-50%, -50%);
      width: 1.375rem;
      height: 1.375rem;
      background-color: transparent;
      border-radius: 50%;
      border: .2rem solid color(background-white);
      border-top-color: color(background-blue);
      animation: 800ms spin linear infinite;
      z-index: 2;
    }
  }

  .invoice-download-is-loading-small > svg {
    visibility: hidden;
  }
</style>
